/**
 * Board 3's calls — `docs/job-stages.md` §9.7, in K52b's shapes
 * (`shared/src/job-stages-api.ts`). The popups ask for nothing else, so an
 * endpoint that changes is one line here.
 */
import type {
  ApprovePreviewAnswer, CancelPreviewAnswer, DeclineReason, JobActionsAnswer, MarkedHow, OfficeApprovalInput,
  OfficeApprovalAnswer, ProposalSelection, ProposalView,
} from '@rowted/shared'
import { request } from '../lib/api.js'

const at = (id: string) => encodeURIComponent(id)

/** `GET /jobs/:id/actions` — the job, its quotes (B's radio rows; D and E's dates) and the first name. */
export const readJobActions = (jobId: string, quoteId?: string) =>
  request<JobActionsAnswer>(`/jobs/${at(jobId)}/actions${quoteId ? `?quote=${at(quoteId)}` : ''}`)

/** The office's proposal — A's choose-one groups and optional extras. */
export const readProposal = (quoteId: string) =>
  request<{ proposal: ProposalView }>(`/quotes/${at(quoteId)}/proposal`).then((body) => body.proposal)

/** `GET /quotes/:id/approve-preview` — A's facts and its grey box, for a selection (left out: the proposal's start). */
export const readApprovePreview = (quoteId: string, selection?: ProposalSelection | null) =>
  request<ApprovePreviewAnswer>(`/quotes/${at(quoteId)}/approve-preview${
    selection ? `?selection=${encodeURIComponent(JSON.stringify(selection))}` : ''}`)

/** The office approve (Board 3 A). */
export const approveQuote = (quoteId: string, body: OfficeApprovalInput) =>
  request<OfficeApprovalAnswer>(`/quotes/${at(quoteId)}/approve`, { method: 'POST', body })

/** Board 3 B. */
export const markQuoted = (quoteId: string, how: MarkedHow | null) =>
  request<unknown>(`/quotes/${at(quoteId)}/mark-quoted`, { method: 'POST', body: { how } })

/** Board 3 D. */
export const withdrawQuote = (quoteId: string, reason: string) =>
  request<unknown>(`/quotes/${at(quoteId)}/withdraw`, { method: 'POST', body: { reason } })

/** Board 3 E. */
export const declineQuote = (quoteId: string, reason: DeclineReason, note: string | null) =>
  request<unknown>(`/quotes/${at(quoteId)}/decline`, { method: 'POST', body: { reason, note } })

/** Board 3 F. */
export const readCancelPreview = (jobId: string) => request<CancelPreviewAnswer>(`/jobs/${at(jobId)}/cancel-preview`)

export const cancelJob = (jobId: string, reason: string) =>
  request<unknown>(`/jobs/${at(jobId)}/cancel`, { method: 'POST', body: { reason } })
